import { Link } from 'react-router-dom';

interface SectionHeaderProps {
  title: string;
  subtitle?: string;
  moreTo?: string;
  moreLabel?: string;
}

export default function SectionHeader({ title, subtitle, moreTo, moreLabel = '查看全部' }: SectionHeaderProps) {
  return (
    <div className="mb-5 flex flex-wrap items-end justify-between gap-3">
      <div className="flex items-center gap-3">
        <span className="h-6 w-1.5 rounded-full bg-primary-500" />
        <div>
          <h2 className="text-lg font-bold text-foreground-950 md:text-xl">{title}</h2>
          {subtitle && <p className="mt-1 text-xs text-foreground-500 md:text-sm">{subtitle}</p>}
        </div>
      </div>
      {moreTo && (
        <Link
          to={moreTo}
          className="flex cursor-pointer items-center gap-1 whitespace-nowrap text-sm text-foreground-600 transition-colors hover:text-primary-600"
        >
          {moreLabel}
          <i className="ri-arrow-right-s-line" />
        </Link>
      )}
    </div>
  );
}